import { Checkbox } from '@/components/ui/checkbox'
import { cn } from '@/lib/utils'

interface Props {
  onSelect: () => void
  selected: boolean
  title: string
  description?: React.ReactNode
  endContent: React.ReactNode
  className?: string
  disabled?: boolean
}
export const OptionCard = ({ onSelect, selected, title, description, endContent, className, disabled }: Props) => {
  return (
    <div
      className={cn(
        'border-border-default rounded-lg border bg-white p-4 shadow-[0_1px_3px_0_rgba(0,0,0,0.08),0_1px_2px_0_rgba(0,0,0,0.05)] transition-colors',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className
      )}
      onClick={disabled ? undefined : onSelect}
    >
      <div className='flex grow items-center justify-between'>
        <div className='flex items-center gap-4'>
          <Checkbox className='self-start cursor-pointer' checked={selected} onChange={() => onSelect()} />
          <div className='grow'>
            <div className='text-text-secondary text-sm font-medium'>{title}</div>
            {description && <div className='text-text-secondary text-sm'>{description}</div>}
          </div>
        </div>
        {endContent}
      </div>
    </div>
  )
}
